import { Labeled, useRecordContext } from "react-admin";

interface Props {}

export const EventSequenceNumberField = (props: Props) => {
  const record = useRecordContext(props);
  return (
    <Labeled label="Event sequence number">
      <span>
        {record?.eventSequenceIdNumber
          ? parseInt(record.eventSequenceIdNumber, 16).toString()
          : "-"}
      </span>
    </Labeled>
  );
};
